import { reactive, defineComponent, watch, computed, onMounted, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import lodash from "lodash";
import { request } from "@/axios";
import Bus from "@/utils/bus";
import store from "@/store";
export default defineComponent({
  name: "IdentityDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  emits: ["close"],
  setup(props, ctx) {
    const state = reactive({
      visible: true,
      identity: undefined,
      service: "",
      serviceName: ""
    });
    watch(() => props.visible, val => {
      state.visible = val;
    }, {
      immediate: true
    });
    watch(() => props.services, val => {
      if (val && val.length === 1) {
        state.service = lodash.get(val, "[0].value", "");
      } else {
        state.service = "";
      }
    }, {
      immediate: true
    });
    const disableUse = computed(() => {
      if (state.identity === undefined) {
        return true;
      }
      if (+state.identity > 0) {
        return false;
      }
      return state.identity === "0" && !state.service;
    });
    const storeIndentityType = computed(() => store.state.userInfo.identityType);
    //选择服务
    const onUse = async () => {
      if (state.identity !== undefined) {
        await getServiceName(state.service);
        const data = {
          identityType: state.identity,
          appkey: state.identity === "0" ? state.service : "",
          serviceName: state.serviceName
        };
        // 切换身份请求
        request.userIdentitySwitch({
          data: data
        }).then(async () => {
          ctx.emit("close", data);
          store.commit("setGuideDialogVisible", store.state.userInfo.stockUser === "1" && !store.state.identityType);
          store.commit("setIdentity", state.identity);
        });
        window.log("manage-login", "switch", "{}");
      } else {
        ElMessage.error("请选择身份");
      }
    };
    const getServiceName = appkey => {
      const currentService = props.services.find(item => {
        return item.value === appkey;
      });
      state.serviceName = currentService?.label || "";
    };
    //切换用户身份
    const onChoose = identity => {
      state.identity = identity;
    };
    const chooseLastIdentity = identity => {
      state.identity = identity;
    };
    onMounted(() => {
      // 选择上次身份
      Bus.on("choose-last-identity", chooseLastIdentity);
    });
    onUnmounted(() => {
      Bus.off("choose-last-identity", chooseLastIdentity);
    });
    return {
      state,
      onUse,
      onChoose,
      getServiceName,
      disableUse,
      props
    };
  }
});